export type ReportedHoursColumnName =
  | "date"
  | "project"
  | "projectOrTask"
  | "customer"
  | "description"
  | "started"
  | "finished"
  | "hours"
  | "status"
  | "worker"
  | "durationInDecimalHours"

export type ReportedHoursVisibleColumnName = Exclude<ReportedHoursColumnName, "project">

export type TreeGridReportedHour = {
  id: string
  date: number | string
  dateFormat: string
  project: string
  projectOrTask: string
  projectOrTaskSearchValue: string
  projectOrTaskExportValue: string
  customer: string
  description: string
  started: string
  finished: string
  hours: string
  hoursClass: string
  hoursFormula: string
  status: string
  durationInDecimalHours: number
  worker: string
  Height: number
  MaxHeight: number
  CanEdit: 0
}

export enum ReportedHoursGroupBy {
  NO_GROUPING = "No Grouping",
  WORKER = "Group by Worker",
  PROJECT = "Group by Project",
  CUSTOMER = "Group by Customer",
  STATUS = "Group by Status",
}
